const dotKeyframes = `
@keyframes dotPulse {
    0%, 80%, 100% { opacity: 0.2; }
    40% { opacity: 1; }
}
`;

const AnimatedDots = () => (
    <>
        <style>{dotKeyframes}</style>
        <span className="inline-flex gap-0.5">
            {[0, 1, 2].map((i) => (
                <span
                    key={i}
                    className="gradient-text"
                    style={{
                        animation: "dotPulse 1.4s infinite ease-in-out",
                        animationDelay: `${i * 200}ms`,
                    }}
                >
                    .
                </span>
            ))}
        </span>
    </>
);

export default AnimatedDots;
